(function (window, document, $) {
    $(document).ready(function () {

        'use strict';

        // only execute this on a certain page template - can be removed when re-used
        if($( "body" ).hasClass('page-template-page-exercise-positions-a-z')) {

            // actual scroll to top function
            function scrollToTop() {
                $(window).scroll(function(){ 
                    if ($(this).scrollTop() > 100) { 
                        $('#scroll').fadeIn(); 
                    } else { 
                        $('#scroll').fadeOut(); 
                    } 
                }); 

                $('.scrollup-function-has-js').click(function(){ 
                    
                    $("html, body").animate({ scrollTop: 0 }, 600); 
                    return false; 
                });
            }

            scrollToTop();
        } // end if cindition
    });

}(window, document, jQuery));